export const QUERY_QUOTAS = 'QUERY_QUOTAS';
export const OPEN_QUERY_QUOTA_MODAL = 'OPEN_QUERY_QUOTA_MODAL';
export const CLOSE_QUERY_QUOTA_MODAL = 'CLOSE_QUERY_QUOTA_MODAL';
export const RESET_QUERY_DATA = 'RESET_QUERY_DATA';
export const CLIENT_IS_ROLLOVER = 'CLIENT_IS_ROLLOVER';
export const OPEN_QUERY_QUOTA_NO_HOLDER_MODAL = 'OPEN_QUERY_QUOTA_NO_HOLDER_MODAL';
export const CLOSE_QUERY_QUOTA_NO_HOLDER_MODAL = 'CLOSE_QUERY_QUOTA_NO_HOLDER_MODAL';